import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';
import { VouchersReponse, VoucherReponse, VoucherState } from './vouchers.interface';
import * as thunks from './vouchersThunks';
import { APIResponse } from '@/types/custom-http';


const initialState: VoucherState = {
  items: [],
  selectedVoucher: null,
  loading: false,
  error: null,
};


// Slice
const vouchersSlice = createSlice({
  name: 'vouchers',
  initialState,
  reducers: {
    clearVouchers: (state) => {
      state.items = [];
    },
    clearSelectedVoucher: (state) => {
      state.selectedVoucher = null;
    },
    clearVoucherError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Obtener todos los Comprobantes de Mercadería Listado Simple
      .addCase(thunks.fetchVouchersSimple.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchVouchersSimple.fulfilled, (state, action: PayloadAction<APIResponse<VouchersReponse>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items = action.payload.data.vouchers;
        }
      })
      .addCase(thunks.fetchVouchersSimple.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Obtener todos los Comprobantes de Mercadería Listado Exposicion Completa
      .addCase(thunks.fetchVouchersComplete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchVouchersComplete.fulfilled, (state, action: PayloadAction<APIResponse<VouchersReponse>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items = action.payload.data.vouchers;
        }
      })
      .addCase(thunks.fetchVouchersComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Obtener un producto específico por ID
      .addCase(thunks.fetchVoucherById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchVoucherById.fulfilled, (state, action: PayloadAction<APIResponse<VoucherReponse>>) => {
        state.loading = false;
        if(action.payload.data){
          state.selectedVoucher = action.payload.data.voucher;
        }
      })
      .addCase(thunks.fetchVoucherById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Crear un nuevo producto
      .addCase(thunks.createVoucher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.createVoucher.fulfilled, (state, action: PayloadAction<APIResponse<VoucherReponse>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items.push(action.payload.data.voucher);
        }
      })
      .addCase(thunks.createVoucher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })
      
  },
});

// Selectors
export const selectAllVouchers = (state: RootState) => state.vouchers.items;
export const selectVoucheryId = (state: RootState, id: number) => state.vouchers.items.find(item => item.id === id);
export const selectSelectedVoucher = (state: RootState) => state.vouchers.selectedVoucher;
export const selectVoucherLoading = (state: RootState) => state.vouchers.loading;
export const selectVoucherError = (state: RootState) => state.vouchers.error;

// Actions
export const { clearVouchers, clearSelectedVoucher,  clearVoucherError} = vouchersSlice.actions;

export default vouchersSlice.reducer;